import React from 'react';
// 修改：从 utils/permission 导入功能权限检查函数
import { hasPermission } from '../utils/permission';

const HasPermi = ({ permission, any = false, children, fallback = null }) => {
  // 如果没有传入权限，默认显示
  if (!permission) {
    return <>{children}</>;
  }

  let hasAccess = false;

  // 处理数组权限
  if (Array.isArray(permission)) {
    if (any) {
      // 任意一个权限满足即可
      hasAccess = permission.some(p => hasPermission(p));
    } else {
      // 需要满足所有权限
      hasAccess = permission.every(p => hasPermission(p));
    }
  } else {
    // 单个权限
    hasAccess = hasPermission(permission);
  }

  // 有权限才显示 children，否则显示 fallback 或 null
  return hasAccess ? <>{children}</> : (fallback || null);
};

export default HasPermi;
